/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketnotvoidableerror3Inputs */

const en_ticketnotvoidableerror3 = /** @type {(inputs: Ticketnotvoidableerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only valid tickets can be voided.`)
};

const de_ticketnotvoidableerror3 = /** @type {(inputs: Ticketnotvoidableerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur gültige Tickets lassen sich ungültig machen.`)
};

/**
* | output |
* | --- |
* | "Only valid tickets can be voided." |
*
* @param {Ticketnotvoidableerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketnotvoidableerror3 = /** @type {((inputs?: Ticketnotvoidableerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketnotvoidableerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketnotvoidableerror3(inputs)
	return de_ticketnotvoidableerror3(inputs)
});
export { ticketnotvoidableerror3 as "ticketNotVoidableError" }